<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ChangeBeforeAfter title="給付方式">
                    <template #before>
                        <ul class="divide-dashed divide-y -mr-2.5 md:-mr-4">
                            <li
                                v-for="(item, index) in before.payDividendList"
                                :key="index"
                                class="flex item-baseline justify-between pr-2.5 md:pr-4 dashed "
                            >
                                <div class="mr-2.5 md:mr-4 w-2/3 md:w-3/4 ">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="w-1/3 min-w-[5.625rem] md:w-1/4 flex-shrink-0">
                                    <span>
                                        {{ item.divKindText }}
                                    </span>
                                </div>
                                <div class="w-1/3 min-w-[5.625rem] md:w-1/4 flex-shrink-0">
                                    <span>
                                        {{ item.divKind === 4 ? item.percent:'' }}
                                    </span>
                                </div>                                
                            </li>
                        </ul>
                    </template>
                    <template #after>
                        <ul class="divide-dashed divide-y -mr-2.5 md:-mr-4 text-gray-900">
                            <li
                                v-for="(item, index) in after.payDividendList"
                                :key="index"
                                class="flex item-baseline justify-between pr-2.5 md:pr-4 dashed "
                            >
                                <div class="mr-2.5 md:mr-4 w-2/3 md:w-3/4 ">
                                    <span>
                                        {{ `${item.fundCode} ${item.fundName}` }}
                                    </span>
                                </div>
                                <div class="w-1/3 min-w-[5.625rem] md:w-1/4 flex-shrink-0">
                                    <span>
                                        {{ item.divKindText }}
                                    </span>
                                </div>
                                <div class="w-1/3 min-w-[5.625rem] md:w-1/4 flex-shrink-0">
                                    <span>
                                        {{ item.divKind === 4 ? item.percent:'' }}
                                    </span>
                                </div>                                     
                            </li>
                        </ul>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, computed } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import { addComma } from '@/utils/number/addComma';

export default {
    name: 'AGData',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('AG');
        const removeService = () => {
            emit('removeService', code.value);
        };
        const after = computed(() => data.value.after);
        const before = computed(() => data.value.before);

        return {
            code,
            data,
            after,
            before,
            addComma,
            removeService,
        };
    },
};
</script>
<style lang="scss" scoped>
.dashed {
    @apply pt-1 pb-1 first:pt-0 last:pb-0.5;
}
</style>
